import { DeviceInfo } from '@/shared/libs';

const FullscreenApi = {
  EXIT_FULLSCREEN: 'exitFullscreen',
  FULLSCREEN_CHANGE: 'fullscreenchange',
  FULLSCREEN_ELEMENT: 'fullscreenElement',
  FULLSCREEN_ENABLED: 'fullscreenEnabled',
  FULLSCREEN_ERROR: 'fullscreenerror',
  REQUEST_FULLSCREEN: 'requestFullscreen',
};

const fullscreenApiMap = [
  [
    FullscreenApi.EXIT_FULLSCREEN,
    FullscreenApi.REQUEST_FULLSCREEN,
    FullscreenApi.FULLSCREEN_ELEMENT,
    FullscreenApi.FULLSCREEN_ENABLED,
    FullscreenApi.FULLSCREEN_CHANGE,
    FullscreenApi.FULLSCREEN_ERROR,
  ],
  [
    'webkitExitFullscreen',
    'webkitRequestFullscreen',
    'webkitFullscreenElement',
    'webkitFullscreenEnabled',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
  ],
  [
    'webkitCancelFullScreen',
    'webkitRequestFullScreen',
    'webkitCurrentFullScreenElement',
    'webkitCancelFullScreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
  ],
  [
    'mozCancelFullScreen',
    'mozRequestFullScreen',
    'mozFullScreenElement',
    'mozFullScreenEnabled',
    'mozfullscreenchange',
    'mozfullscreenerror',
  ],
  [
    'msExitFullscreen',
    'msRequestFullscreen',
    'msFullscreenElement',
    'msFullscreenEnabled',
    'MSFullscreenChange',
    'MSFullscreenError',
  ],
];

const getFullscreenApi = () => {
  let browserApi;
  let api = null;
  for (let i = 0; i < fullscreenApiMap.length; i++) {
    if (fullscreenApiMap[i][0] in document) {
      browserApi = fullscreenApiMap[i];
      break;
    }
  }
  if (browserApi) {
    api = {};
    for (let i = 0; i < browserApi.length; i++) {
      api[fullscreenApiMap[0][i]] = browserApi[i];
    }
  }
  return api;
};

const fullscreenApi = getFullscreenApi();
const isIOS = DeviceInfo.isIOS();

const isFullscreen = (rendererObj) => {
  if (isIOS) {
    return !!rendererObj.webkitDisplayingFullscreen;
  }

  if (fullscreenApi) {
    return !!document[fullscreenApi[FullscreenApi.FULLSCREEN_ELEMENT]];
  }

  return false;
};

const toggleFullscreen = (rendererObj, holder) => {
  if (isIOS) {
    if (isFullscreen(rendererObj)) {
      rendererObj.webkitExitFullscreen();
    } else {
      rendererObj.webkitEnterFullscreen();
    }
  }

  if (fullscreenApi) {
    if (isFullscreen(rendererObj)) {
      document[fullscreenApi[FullscreenApi.EXIT_FULLSCREEN]]();
    } else {
      holder[fullscreenApi[FullscreenApi.REQUEST_FULLSCREEN]]();
    }
  }
};

const fullscreenChange = (rendererObj, holder) => {
  if (fullscreenApi) {
    togglePlayerClass(rendererObj, holder);
  }
};

const togglePlayerClass = (rendererObj, holder) => {
  if (isFullscreen(rendererObj)) {
    holder.classList.add('is-fullscreen');
  } else {
    holder.classList.remove('is-fullscreen');
  }
};

const addFullscreenListener = (callback) => {
  document.addEventListener('mozfullscreenchange', callback);
  document.addEventListener('webkitfullscreenchange', callback);
  document.addEventListener('msfullscreenchange', callback);
  document.addEventListener('fullscreenchange', callback);
};

const removeFullscreenListener = (callback) => {
  document.removeEventListener('mozfullscreenchange', callback);
  document.removeEventListener('webkitfullscreenchange', callback);
  document.removeEventListener('msfullscreenchange', callback);
  document.removeEventListener('fullscreenchange', callback);
};

export {
  addFullscreenListener,
  isFullscreen,
  fullscreenChange,
  removeFullscreenListener,
  toggleFullscreen,
};
